module.exports = __webpack_public_path__ + "static/media/rosto.9276f2f2.svg";